"use client"

import { useEffect, useRef } from "react"
import "../assets/css/hero-section.css"
import vid from "../assets/images/gbc.mp4"

export default function HeroSection() {
  const titleRef = useRef<HTMLHeadingElement>(null)
  const subtitleRef = useRef<HTMLParagraphElement>(null)
  const buttonRef = useRef<HTMLAnchorElement>(null)

  useEffect(() => {
    const title = titleRef.current
    const subtitle = subtitleRef.current
    const button = buttonRef.current

    if (title) title.classList.add("animate-fadeInUp")
    if (subtitle) {
      setTimeout(() => {
        subtitle.classList.add("animate-fadeInUp")
      }, 300)
    }
    if (button) {
      setTimeout(() => {
        button.classList.add("animate-fadeInUp")
      }, 600)
    }
  }, [])

  return (
    <section id="home" className="hero-section">
      <div className="hero-background">
        <div className="overlay"></div>
        <video
          src={vid}
          // poster={img}
          autoPlay
          muted
          loop
          playsInline
          className="background-image"
        />
      </div>

      <div className="hero-content">
        <h1 ref={titleRef} className="hero-title">
          <span className="title-red">Farming Smarter</span>
          <br />
          <span className="title-white">Growing Greener</span>
        </h1>
        <p ref={subtitleRef} className="hero-subtitle">
            Discover the future of sustainable farming and premium produce from the heart of Sri Lanka.
        </p>
        <a ref={buttonRef} href="#products" className="hero-button">
          Discover Our Products
        </a>
      </div>

      <div
        className="scroll-indicator"
        role="button"
        tabIndex={0}
        onClick={() => {
          const el = document.getElementById("products");
          if (el) {
            el.scrollIntoView({ behavior: "smooth" });
          }
        }}
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            const el = document.getElementById("products");
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            }
          }
        }}
        aria-label="Scroll to products section"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 5V19M12 19L5 12M12 19L19 12"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </section>
  )
}
